// removed by extract-text-webpack-plugin
module.exports = {"root":"ItemAttributes--root--1V","_power":"ItemAttributes--_power--qN","elementalDamageIcon":"ItemAttributes--elementalDamageIcon--3I","ammoIcon":"ItemAttributes--ammoIcon--6W","kineticDamage":"ItemAttributes--kineticDamage--dX ItemAttributes--_power--qN","voidDamage":"ItemAttributes--voidDamage--lw ItemAttributes--_power--qN","arcDamage":"ItemAttributes--arcDamage--3J ItemAttributes--_power--qN","solarDamage":"ItemAttributes--solarDamage--3J ItemAttributes--_power--qN","stasisDamage":"ItemAttributes--stasisDamage--2u ItemAttributes--_power--qN","ammoType":"ItemAttributes--ammoType--1E"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ItemAttributes/styles.styl
// module id = 843
// module chunks = 0